import { z } from "zod";

export const PaginatedSchema = <T extends z.ZodTypeAny>(object: T) =>
  z.object({
    data: z.array(object),
    links: z.object({
        first: z.string().nullable(),
        last:  z.string().nullable(),
        prev: z.string().nullable().optional(),
        next: z.string().nullable().optional(),
    }),
    meta: z.object({
        path:        z.string(),
        per_page:    z.number(),
        next_cursor: z.string().nullable(),
        prev_cursor: z.string().nullable(),
    }),
  });  